<template>
  <section id="landing">
    <v-container fluid>
      <v-row no-gutters class="navbar__signup_process">
        <v-col>
          <v-img class="logo" src="/logo_blanc.png" contain max-width="150">
          </v-img>
        </v-col>
        <v-col >
          <v-row class="quit_logo">

                   
              <v-btn v-if="userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username)"
                :color="userData.status=='ACTIVE'?'#FFED00':'#FF3333'"
                v-on:click="unset_loginas"
                class="black--text"
              >
                {{userData.username}}    
              </v-btn>  

              <v-btn
                color="primary"
                icon
                @click="logout"
              >
                <v-icon large>mdi-logout</v-icon>
              </v-btn>

          </v-row>
        </v-col>
      </v-row>
      <slot>
        <v-container>
          <v-row align="center" justify="center" class="mt-10">
            <v-card>
              <v-card-text class="black--text"> Landing example </v-card-text>
            </v-card>
          </v-row>
        </v-container>
      </slot>
    </v-container>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "Landing",
  computed: {
    ...mapGetters({
      userData: 'me/userData',
    }),
    ...mapState([
      'session_information',
    ]),
  },
  mounted(){
    this.changeCrispColor("light_blue");
  },
  methods: {
    ...mapActions({
      signOut: "signOut",
      unsetLoginas: 'unsetLoginas',
      changeCrispColor: "changeCrispColor"
    }),
    logout() {
      this.signOut().then(() => {
        this.$router.replace({ name: 'login' }, () => {
          window.location.reload();
        });
      });
    },
    unset_loginas() {  
      let aux = {
        'logged_username': this.session_information.username,
        'loginas_username': this.userData.username,
      };
      this.unsetLoginas(aux).then(()=>{
        this.$router.push({'name': 'dashboard'});
        this.$router.go();
      });
    },
  },
}
</script>

<style lang="scss">
#landing {
  background-image: url('/inmatic_bg_nohand.jpg');
  background-position: center;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  justify-content: flex-end;
  color: white;
  font-family: 'Roboto', sans-serif !important;

  .navbar__signup_process{
    padding: 60px 70px 0px 60px !important;
  }

  .quit_logo {
    justify-content: flex-end;
  }
  .headline,
  .display-1,
  .display-2,
  .display-3,
  .display-4 {
    font-family: "Roboto", sans-serif !important;
  }

  ::selection {
    background: #3cf;
    color: #5d3c9f;
  }

  .quit_logo .theme--light.v-icon {
    color: white;
  }
  .v-input .v-messages,
  .v-text-field__details {
    display: none;
  }
  .v-input.v-text-field.error--text .v-input__slot {
    box-shadow: 1px 1px 1px 2px red !important;
  }
  
  .v-stepper,
  .v-stepper__header {
    background: transparent;
    box-shadow: none;
  }
  .v-stepper__step {
    .v-stepper__step__step {
      background-color: white;
      color: #3cf;
      font-size: 1.25em;
      width: 40px;
      height: 40px;
    }
    &.v-stepper__step--active {
      .v-stepper__step__step.primary {
        background-color: yellow !important;
      }
    }
  }

  .v-stepper .v-divider {
    border-width: 1px;
    border-color: white;
  }
  .v-input__control {
    width: 100%;
  }
  .v-stepper__content {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  a {
    color: black;
  }
  .col,
  .rol,
  .container {
    padding-bottom: 0;
  }

  @media screen and (max-width: 600px) {
    .navbar__signup_process{
      padding: 10px 10px 0px 10px !important;
    }
  }
}
</style>
